<template>
  <section class="views">
    <headers select="6"></headers>
    <div class="event-review">
      <div class="event-container">
        <div v-for="item in events" :key="item.id" class="event-item">
          <div class="timeline-column">
            <div class="event-dot-wrapper">
              <span class="event-dot"></span>
            </div>
            <div class="event-date">
              <div class="year">{{ item.year }}</div>
              <div class="day">{{ item.date }}</div>
            </div>
          </div>
          <div class="event-cards">
            <div
              v-for="(card, index) in item.list"
              :key="card.title + index"
              class="event-card"
            >
              <div
                @click="openResult(card.resultUrl)"
                @keyup.enter="openResult(card.resultUrl)"
                role="button"
                tabindex="0"
              >
                <div class="event-card-image">
                  <img :src="card.image" :alt="card.title" />
                </div>
                <div class="event-card-body">
                  <h3 class="event-title">{{ card.title }}</h3>
                  <!-- <a
                  class="event-result-link"
                  :href="card.resultUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                    <span
                      style="
                        display: inline-flex;
                        align-items: center;
                        gap: 5px;
                      "
                    >
                      比賽結果
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M2 8h12"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                        <path
                          d="M10 4l4 4-4 4"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                </a> -->
                </div>
              </div>
              <div
                class="event-card-footer"
                v-if="card.media && card.media.length"
              >
                <div class="media-label">報道媒體：</div>
                <!-- <div class="media-list"> -->
                <a
                  v-for="(mediaItem, idx) in card.media"
                  :key="mediaItem.name + idx"
                  class="media-link"
                  :href="mediaItem.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ mediaItem.name }}
                </a>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
import eventReviewList from "@/config/eventReview";
const isIOS = /(iPhone|iPad|iPod|iOS)/.test(navigator.userAgent);
export default {
  name: "views",
  data() {
    return {
      events: eventReviewList,
    };
  },
  components: {
    headers,
  },
  methods: {
    openResult(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);
}

.event-review {
  width: 100%;
  padding: 20px 12px 40px;

  .event-container {
    width: 100%;
    margin: 0;
    padding-bottom: 20px;
    position: relative;
  }

  .event-container::before {
    content: "";
    position: absolute;
    left: 24px;
    top: 12px;
    bottom: 20px;
    width: 1px;
    background: rgba(255, 255, 255, 0.5);
  }

  .event-item {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    padding-left: 24px;
  }
  .event-item:last-child {
    margin-bottom: 0;
  }

  .timeline-column {
    display: flex;
    align-items: center;
  }

  .event-dot-wrapper {
    position: relative;
    left: -12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(254, 228, 127, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .event-dot {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(254, 228, 127, 1) 0%,
      rgba(254, 228, 127, 1) 30%,
      rgba(254, 228, 127, 0.61) 50%,
      rgba(254, 228, 127, 0.31) 70%,
      rgba(254, 228, 127, 0.19) 100%
    );
    z-index: 9;
  }

  .event-date {
    color: #fff;
    font-family: PingFang SC, PingFang SC;
    display: flex;
    align-items: flex-end;
    gap: 4px;
    .year {
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 1px;
      margin-right: 5px;
    }
    .day {
      font-size: 18px;
      padding-bottom: 1px;
    }
  }

  .event-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 12px 0 12px;
  }

  .event-card {
    border: 2px solid #ffd900;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    padding-bottom: 8px;
    box-sizing: border-box;
  }

  .event-card-image {
    padding: 8px;
    box-sizing: border-box;
  }

  .event-card-image img {
    width: 100%;
    height: 172px;
    object-fit: cover;
    display: block;
    border-radius: 12px;
  }

  .event-card-body {
    padding: 8px;
    text-align: left;
  }

  .event-title {
    font-size: 18px;
    font-weight: 600;
    color: #424141;
    margin: 0 0 6px;
    line-height: 1.4;
  }

  .event-result-link {
    font-size: 16px;
    color: #ff782f;
    text-decoration: underline;
    font-weight: 600;
    display: inline-block;
  }

  .event-card-footer {
    padding: 8px 18px 16px;
    border-top: 1px solid #f2f2f2;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .media-label {
    font-size: 14px;
    color: #999999;
    white-space: nowrap;
  }

  .media-list {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
  }

  .media-link {
    font-size: 14px;
    color: #333333;
    text-decoration: underline;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .event-review {
    padding: 14px 0 0px;

    .event-container {
      width: 100%;
    }

    .event-item {
      padding-left: 24px;
    }

    .event-card-image img {
      height: 160px;
    }
  }
}

@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .views {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
